/**
 * This is app main js file,
 * global variable for load more part, it's coming from localize script in blog-modification.php
 * global variable for pricingLookup it's coming from localize script in setup.php
 */
/* global loadMoreVariables */
/* global pricingLookup */

// sliders
import './modules/quote-slider'
import './modules/testimonial-slider'
import './modules/homepage-slider'
import './modules/image-carousel'
import './modules/video-carousel'
import './modules/case-study-cards-carousel'

// import modules
// navigation
import './modules/mobile-toggle';
import './modules/mobile-dropdown-logic';


// hover on blog logic for masonry grid
import './modules/articles-hover'
import './modules/featured-post-hover'

// hover on events - slightly different from one on blog
import './modules/events-hover'


// blog logic
import LoadMore from './modules/LoadMore';

if (document.body.classList.contains('blog') || document.body.classList.contains('archive')) {
    // masonry grid on blog posts
    const loadMorePosts = new LoadMore(loadMoreVariables);
    loadMorePosts.run()
}


// blocks related scripts
import './modules/masonry-cards-grid'

// hero arrow
import './modules/hero-arrow'

// price calculator - need to be before AlpineJS init
import PriceCalculator from "./modules/calculate-price";
global.PriceCalculator = new PriceCalculator(pricingLookup.data)

import './modules/choose-plan'

// import Alpine.js - used on multiple blocks
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// 404 page animation
import './modules/404-sheep'

// import region selector logic
import './modules/region-selector'

/**
 * Add event listener to menu item 'Live Chat' in footer of theme and on pricing page
 */
document.querySelectorAll('.intercom-show a, a.intercom-show').forEach(e => {
    e.addEventListener('click', e => {
        e.preventDefault()
        window.Intercom('show')
    })
})

function onSustainabilityPagesLoad() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    const sustainabilityCorporate = document.querySelector('.sustainability-corporate-hero')

    if (sustainabilityCorporate) {
        const imgBackgroundBanner = sustainabilityCorporate.querySelector('img[class*=__background]');

        if (imgBackgroundBanner) {
            if (!isMobile) {
                imgBackgroundBanner.style.top = '110px'
            }
            
            $('.site-header.wrapper').addClass('sticky');
            $('.header-wrapper').addClass('sticky');
        }
    }
}
// eslint-disable-next-line no-unused-vars 
window.addEventListener('scroll', (e) => {
    //    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
    if (window.scrollY >= $('.site-header.wrapper').height()) {
        $('.site-header.wrapper').addClass('sticky');
        $('.header-wrapper').addClass('sticky');
        $('.site-header.sticky').css({ "position": "fixed", "background-color": "var(--color-grey-100)" });
        if ($('.has-hero-dark')[0] || $('.single-event')[0] || $('.single-guide')[0] || $('.pricing')[0]) {
            $('.site-header.sticky').css({ "background-color": "var(--color-blue)" });
        }
    }
    else {
        $('.site-header.wrapper').removeClass('sticky');
        $('.header-wrapper').removeClass('sticky');
        $('.site-header.wrapper').css({ "position": "absolute", "background-color": "inherit" });

        onSustainabilityPagesLoad();
    }
    //    }
});

onSustainabilityPagesLoad()

